import script from "./AddToPlaylistDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToPlaylistDropdown.vue?vue&type=script&setup=true&lang=js"

import "./AddToPlaylistDropdown.vue?vue&type=style&index=0&id=d3063fd2&lang=css"

const __exports__ = script;

export default __exports__